module.exports = __webpack_public_path__ + "img/logo6.22c09720.png";